import { readCookie } from "../utils/cookies";

// fix undeclared variable in window
declare global {
    interface Window {
        LANGUAGE_CODE: string;
    }
}

function format_url_params(params) {
    const query_string = Object.keys(params)
        .map(function (key) {
            return key + "=" + encodeURIComponent(params[key]);
        })
        .join("&");

    return "?" + query_string;
}

export class JSONRequests {
    static get(url, params?) {
        if (params) {
            url = url + format_url_params(params);
        }
        return this.request("get", url);
    }

    static post(url, data?, multipart = false) {
        return this.request("post", url, data, multipart);
    }

    static request(method, url, data?, multipart = false): Promise<any> {
        // made classic XHR, but return it as Promise.
        // all input and output data will be JSON

        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url);

            xhr.setRequestHeader("X-CSRFToken", readCookie("csrftoken"));
            xhr.setRequestHeader("X-LanguageCode", window.LANGUAGE_CODE);

            xhr.onload = function () {
                if (this.status >= 200 && this.status < 300) {
                    resolve(JSON.parse(xhr.responseText));
                } else {
                    reject({
                        status: this.status,
                        statusText: xhr.statusText,
                        response: xhr.responseText,
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    status: this.status,
                    statusText: xhr.statusText,
                    response: xhr.response,
                });
            };

            if (multipart) {
                // sends  as multipart/form-data, do not support nested objects

                // https://stackoverflow.com/questions/9395911/send-a-file-as-multipart-through-xmlhttprequest
                // https://stackoverflow.com/questions/41431322/how-to-convert-formdata-html5-object-to-json
                // https://stackoverflow.com/questions/53160115/handling-javascript-formdata-combined-with-json-data-in-an-xmlhttprequests-post
                // https://stackoverflow.com/questions/50774176/sending-file-and-json-in-post-multipart-form-data-request-with-axios

                const form_data = new FormData();
                for (let key in data) {
                    form_data.append(key, data[key]);
                }
                xhr.send(form_data);
            } else {
                // sends as json
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.send(JSON.stringify(data));
            }
        });
    }
}
